import ReactDOM from "react-dom/client";
import "./index.css";
// PDF viewer core styles - required for @react-pdf-viewer/core
import "@react-pdf-viewer/core/lib/styles/index.css";
// PDF viewer highlight plugin styles - required for @react-pdf-viewer/highlight
import "@react-pdf-viewer/highlight/lib/styles/index.css";
// PDF viewer search plugin styles - required for @react-pdf-viewer/search
import "@react-pdf-viewer/search/lib/styles/index.css";
import App_Component from "./App_Component";
import ErrorBoundary from "./ErrorBoundary";
import AuthProvider from "./components/auth/AuthProvider";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Failed to find root element");
}

ReactDOM.createRoot(rootElement).render(
  // <React.StrictMode>
  <ErrorBoundary>
    <AuthProvider>
      <App_Component />
    </AuthProvider>
  </ErrorBoundary>
  // </React.StrictMode>
);
